import React, { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";
import { NAV_LINKS, CONTACT, LOGO } from "../mock";
import { Button } from "../components/ui/button";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (id) => {
    setOpen(false);
    scrollTo(id);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/95 shadow-lg backdrop-blur" : "bg-white/80 backdrop-blur"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-[72px]">
          {/* Logo */}
          <button
            onClick={() => handleNav("home")}
            className="flex items-center gap-3 group"
          >
            <img
              src={LOGO}
              alt="Mallikarjuna Tours & Travels"
              className="h-12 sm:h-14 w-auto object-contain"
            />
          </button>

          {/* Desktop nav */}
          <nav className="hidden lg:flex items-center gap-8">
            {NAV_LINKS.map((l) => (
              <button
                key={l.to}
                onClick={() => handleNav(l.to)}
                className="relative text-sm font-medium text-stone-700 hover:text-orange-700 transition-colors after:absolute after:left-0 after:-bottom-1 after:h-0.5 after:w-0 after:bg-orange-600 hover:after:w-full after:transition-all"
              >
                {l.label}
              </button>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a href={`tel:+91${CONTACT.primary}`} className="hidden sm:block">
              <Button className="bg-orange-600 hover:bg-orange-700 text-white rounded-full gap-2 shadow-md">
                <Phone className="h-4 w-4" />
                {CONTACT.primary}
              </Button>
            </a>
            <button
              className="lg:hidden p-2 text-orange-900"
              onClick={() => setOpen((v) => !v)}
              aria-label="Toggle menu"
            >
              {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden bg-white border-t border-amber-100 shadow-lg">
          <nav className="flex flex-col px-6 py-4">
            {NAV_LINKS.map((l) => (
              <button
                key={l.to}
                onClick={() => handleNav(l.to)}
                className="py-3 text-left text-stone-700 border-b border-amber-50 last:border-0"
              >
                {l.label}
              </button>
            ))}
            <a href={`tel:+91${CONTACT.primary}`} className="mt-3">
              <Button className="w-full bg-orange-600 hover:bg-orange-700 text-white rounded-full gap-2">
                <Phone className="h-4 w-4" /> Call {CONTACT.primary}
              </Button>
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Navbar;
